import { Node, mergeAttributes, CommandProps, RawCommands } from '@tiptap/core';

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        referenceList: {
            addReferenceItem: () => ReturnType;
        };
    }
}

export const ReferenceItem = Node.create({
    name: 'referenceItem',
    content: 'inline*',
    group: 'block',

    parseHTML() {
        return [{ tag: 'li[data-type="referenceItem"]' }];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            'li',
            mergeAttributes(HTMLAttributes, { 'data-type': 'referenceItem' }),
            0,
        ];
    },
});

export const ReferenceList = Node.create({
    name: 'referenceList',
    content: 'referenceItem+',
    group: 'block',

    parseHTML() {
        return [{ tag: 'ol[data-type="referenceList"]' }];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            'ol',
            mergeAttributes(HTMLAttributes, { 'data-type': 'referenceList' }),
            0,
        ];
    },

    addCommands(): Partial<RawCommands> {
        return {
            addReferenceItem:
                () =>
                ({ chain }: CommandProps) => {
                    return chain()
                        .insertContent({
                            type: 'referenceList',
                            content: [{ type: 'referenceItem', content: [] }],
                        })
                        .run();
                },
        };
    },
});
